import { post } from "@/utils/utils";
import moment from "moment";
 
const member = {
  state: {
    memberList: [],
    orderDetail: {},
    purchaseHistory: [],
    appointmentRecord: [],
    writeOffRecord: [],
    recordWithCard: []
  },
  mutations: {
    MEMBER_LIST(state, data) {
      state.memberList = data.result;
      state.memberList.list.forEach(v => {
        v.regTimeFormat = v.regTime
          ? moment(v.regTime).format("YYYY-MM-DD HH:mm:ss")
          : "";
        v.lastTimeFormat = v.lastTime
          ? moment(v.lastTime).format("YYYY-MM-DD HH:mm:ss")
          : "";
      });
    },
    ORDER_DETAIL(state, data) {
      state.orderDetail = data.result;
    },
    PURCHASE_HISTORY(state, data) {
      state.purchaseHistory = data.result;
      state.purchaseHistory.forEach(v => {
        v.addTimeFormat = v.addTime
          ? moment(v.addTime).format("YYYY-MM-DD HH:mm:ss")
          : "";
      });
    },
    APPOINTMENT_RECORD(state, data) {
      state.appointmentRecord = data.result;
      state.appointmentRecord.forEach(v => {
        v.startDateFormat = v.startDate
          ? moment(v.startDate).format("YYYY-MM-DD HH:mm:ss")
          : "";
        v.endDateFormat = v.endDate
          ? moment(v.endDate).format("YYYY-MM-DD HH:mm:ss")
          : "";
        switch (v.status) {
          case 0:
            v.statusFormat = "已预约";
            break;
          case 2:
            v.statusFormat = "已过期";
            break;
          case 3:
            v.statusFormat = "已取消";
            break;
          case 4:
            v.statusFormat = "待审核";
            break;
          case 5:
            v.statusFormat = "已驳回";
            break;
          default:
            break;
        }
      });
    },
    WRITE_OFF_RECORD(state, data) {
      state.writeOffRecord = data.result;
      state.writeOffRecord.forEach(v => {
        v.checkDateFormat = v.checkDate
          ? moment(v.checkDate).format("YYYY-MM-DD HH:mm:ss")
          : "";
      });
    },
    RECORD_WITH_CARD(state, data) {
      state.recordWithCard = data.result;
      state.recordWithCard.forEach(v => {
        v.useTimeFormat = v.useTime
          ? moment(v.useTime).format("YYYY-MM-DD HH:mm:ss")
          : "";
        v.useStatusFormat = v.useStatus === 0 ? "未使用" : "已使用";
      });
    }
  },
  actions: {
    queryPurchaseHistory({ commit }, params) {
      return post({
        commit,
        url: `/server-back/member_order_record`,
        name: "PURCHASE_HISTORY",
        params
      });
    },
    queryAppointmentRecord({ commit }, params) {
      return post({
        commit,
        url: `/server-back/member_order_server_record`,
        name: "APPOINTMENT_RECORD",
        params
      });
    },
    queryWriteOffRecord({ commit }, params) {
      return post({
        commit,
        url: `/server-back/member_check_record`,
        name: "WRITE_OFF_RECORD",
        params
      });
    },
    queryRecordWithCard({ commit }, params) {
      return post({
        commit,
        url: `/server-back/member_card_record`,
        name: "RECORD_WITH_CARD",
        params
      });
    }
  }
};

export default member;
